import React, { useEffect, useState } from 'react';
import CoachPageLayout from '../../components/CoachPageLayout/CoachPageLayout';
import ArchivedCoaches from '../../components/CoachesTable/ArchivedCoaches/ArchivedCoaches';
import { useAppDispatch, useAppSelector } from '../../redux/hooks';
import { fetchArchivedCoaches } from '../../redux/coach/coachSlice';
import { PaginationModelChangeProps } from '../../components/CoachesTable/CoachesTable';

export interface CoachesProps {
  pageSize: number;
  currentPage: number;
  skip: number;
  handleOnPaginationModelChange: (_event: PaginationModelChangeProps) => void;
}

const ArchivedCoachesView = () => {
  const dispatch = useAppDispatch();
  const coach = useAppSelector((state) => state.coach.coaches);

  // archived coaches
  const [pageSizeArchived, setPageSizeArchived] = useState<number>(40);
  const [currentPageArchived, setCurrentPageArchived] = useState<number>(0);
  const skipArchived = currentPageArchived * pageSizeArchived;

  const handlePaginatiChangeArchived = (event: PaginationModelChangeProps) => {
    setPageSizeArchived(event.pageSize);
    setCurrentPageArchived(event.page);
  };

  useEffect(() => {
    if (coach) {
      const payload = {
        organizationId: 'decb4748-9dba-4672-b0c2-88aad43fc307',
        nameText: '',
        skip: skipArchived,
        take: pageSizeArchived,
        archived: true,
      };
      dispatch(fetchArchivedCoaches(payload));
    }
  }, []);

  return (
    <CoachPageLayout>
      <ArchivedCoaches
        pageSize={pageSizeArchived}
        currentPage={currentPageArchived}
        skip={skipArchived}
        handleOnPaginationModelChange={handlePaginatiChangeArchived}
      />
    </CoachPageLayout>
  );
};

export default ArchivedCoachesView;
